import { TableData } from '@/components/TableData/TableData';
import TableLayout from '@/layouts/TableLayout/TableLayout';
import { useGlobalOrdersViewController } from './GlobalOrdersViewController';
import { OrderDetailsDialog } from './OrderDetailsDialog';
import { itemGenerator } from './TableItem';

export function GlobalOrdersContainer() {
  const { uiState, actions } = useGlobalOrdersViewController();

  return (
    <>
      <TableLayout
        isLoading={uiState.isLoading}
        body={
          <>
            <TableData
              columnHeaders={uiState.columnHeaders}
              items={uiState.items}
              rowItemGenerator={itemGenerator}
              onRowClick={actions.onOrderClicked}
              paging={uiState.paging}
              onPageSelected={actions.onPageRequested}
              roundedTop={true}
              compact={true}
            />
          </>
        }
      />
      <OrderDetailsDialog
        open={!!uiState.selectedOrder}
        onClose={actions.onDialogClose}
        selectedOrderUi={uiState.selectedOrder}
        isLoading={!!uiState.isLoadingOrderDetails}
        error={uiState.orderDetailsError ?? null}
      />
    </>
  );
}
